import { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';

export default function FloatingCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('hero');
    if (!hero) return;
    const obs = new IntersectionObserver(
      ([entry]) => setShow(!entry.isIntersecting),
      { threshold: 0 }
    );
    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  return (
    <div className={`floating-cta fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-neutral-200 px-4 py-3 ${show ? 'show' : ''}`}>
      <div className="flex gap-2">
        <a href="tel:1644-6827" className="flex items-center justify-center gap-2 flex-1 bg-brand-400 text-neutral-900 font-semibold py-3.5 rounded-xl text-sm">
          <Icon icon="solar:phone-calling-bold" className="text-lg" />
          전화 상담
        </a>
        <a href="http://pf.kakao.com/_fgiMX/chat" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 flex-1 bg-neutral-900 text-white font-semibold py-3.5 rounded-xl text-sm">
          <Icon icon="solar:chat-round-dots-bold" className="text-lg" />
          카카오톡
        </a>
      </div>
    </div>
  );
}
